import request from '@/utils/request'

/**
 * 获取用户拼团订单列表
 * @param {Object} params 查询参数
 * @param {String} params.buyerId 购买者ID
 * @param {Number} params.page 页码
 * @param {Number} params.row 每页条数
 * @returns {Promise} 返回请求的Promise对象
 */
export function getGroupOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productGroup.queryAdminGroupOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}